export const ROOT = '/'
export const LANDING = ROOT
export const LOGOUT_TARGET = ROOT
export const ONBOARDING = '/onboarding'
export const SCHEDULES = '/schedules'
export const SETTINGS = '/settings'
